/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p27.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getReportOneDayDBCount, getContentNum} from '../../../controller';
import {brandValueBar} from '../../../chart';
import moment from 'moment';
import { toThousands } from '../../../utils';
import { buttomDate } from '../exportPDFConfig';

class P27 extends React.Component {
  constructor (props) {
    super(props);

    const {query, name} = this.props;

    

    this.state = {
      query: {
        brandName: name,
        startDate: query.startDate,
        statisDate: query.statisDate
      },
      summary: {
        maxDate: '',
        maxDb: 0,
        minDate: '',
        minDb: 0
      },
      count: 0,
      color: this.props.color,
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }


  getData () {
    const query = this.state.query;
    this.getReportOneDayDBCount(query);
    this.getCount(query);
  }

  getReportOneDayDBCount (query) {
    const color = this.state.color;
    getReportOneDayDBCount(Object.assign({report: true}, query))
      .then(data => {
        this.setState({
          summary: {
            maxDate: data.maxDate,
            maxDb: toThousands(data.maxDb),
            minDate: data.minDate,
            minDb: toThousands(data.minDb)
          },
          chart: brandValueBar(data, Object.assign({
            title: '四大社交媒体平台单日总DB值'
          }, query), color)
        })
      });
  }


  getCount (query) {
    getContentNum({
      brandName: query.brandName,
      startDate: query.startDate,
      statisDate: query.statisDate
    })
      .then(res => {
        this.setState({
          count: res.contentNum
        })
      })
  }

  render() {
    const {query, summary, count} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>竞品数字品牌价值-{query.brandName}</ExportHeadTitle>

        <div>
          <ExportDes> 
            本周，{query.brandName}在四大社交媒体平台上的单日DB总值波峰日为{moment(summary.maxDate).format('M月D日')}，达到{summary.maxDb}<em>DB</em>；
            波谷日为{moment(summary.minDate).format('M月D日')}，DB值为{summary.minDb}<em>DB</em>。 </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes>
          本页图表数据观测窗口为{moment(query.startDate).format(buttomDate)}-{moment(query.statisDate).format(buttomDate)}，数据源来自微博、微信、今日头条、知乎四大国内主流社交媒体平台上的用户行为信息和UGC内容。与{query.brandName}相关的内容贴总数为：{toThousands(count || 0)} 条。
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P27);



// WEBPACK FOOTER //
// src/routes/exportPDF/p27/p27.chart.js